/**
 * Lightweight contiguous-US silhouette (no map libraries).
 * TODO: Confirm which states/regions Fox Trucking actively serves.
 * Default highlight = all lower 48; refine fill/legend when confirmed.
 */
export function UsCoverageMap() {
  const titleId = "us-coverage-map-title";
  const descId = "us-coverage-map-desc";

  return (
    <figure className="overflow-hidden rounded-lg border border-border bg-card p-4 sm:p-6">
      <svg
        viewBox="0 0 1000 620"
        className="h-auto w-full"
        role="img"
        aria-labelledby={`${titleId} ${descId}`}
      >
        <title id={titleId}>
          Fox Trucking service coverage across the contiguous United States
        </title>
        <desc id={descId}>
          Stylized map of the lower 48 United States. All contiguous states are highlighted as the
          default service area pending confirmation. New Jersey, the company home base, is marked
          with a pin near the Northeast coast.
        </desc>

        <rect width="1000" height="620" fill="var(--color-muted)" rx="4" />

        {/*
          Stylized lower-48 silhouette (compact, not survey-grade).
          TODO: Swap uniform fill for confirmed states/regions when provided.
        */}
        <path
          fill="var(--color-primary)"
          fillOpacity="0.9"
          stroke="var(--color-accent)"
          strokeWidth="2.5"
          strokeLinejoin="round"
          d="
            M 95 165
            L 130 95
            L 210 78
            L 320 68
            L 430 72
            L 540 85
            L 640 98
            L 720 88
            L 780 105
            L 820 145
            L 845 195
            L 855 250
            L 848 305
            L 825 355
            L 790 390
            L 760 415
            L 745 455
            L 755 500
            L 740 535
            L 710 520
            L 685 545
            L 650 555
            L 610 540
            L 570 555
            L 530 565
            L 490 550
            L 455 565
            L 420 555
            L 385 530
            L 350 505
            L 300 485
            L 250 455
            L 210 420
            L 175 380
            L 145 335
            L 125 285
            L 110 230
            Z
          "
        />

        {/* Florida */}
        <path
          fill="var(--color-primary)"
          fillOpacity="0.9"
          stroke="var(--color-accent)"
          strokeWidth="2"
          strokeLinejoin="round"
          d="M 760 415 L 790 435 L 805 480 L 812 530 L 795 555 L 778 525 L 768 475 L 755 440 Z"
        />

        {/* Great Lakes (negative space) */}
        <ellipse cx="640" cy="155" rx="52" ry="24" fill="var(--color-muted)" />
        <ellipse cx="700" cy="175" rx="30" ry="16" fill="var(--color-muted)" />
        <ellipse cx="600" cy="175" rx="22" ry="12" fill="var(--color-muted)" />

        {/* New Jersey home-base marker (approx. Mid-Atlantic coast) */}
        <g transform="translate(805 250)">
          <circle r="16" fill="var(--color-accent)" />
          <circle r="7" fill="var(--color-secondary)" />
          <text
            y="32"
            textAnchor="middle"
            fill="var(--color-secondary)"
            style={{ fontSize: "16px", fontWeight: 700, letterSpacing: "0.06em" }}
          >
            NJ
          </text>
        </g>

        <text
          x="500"
          y="600"
          textAnchor="middle"
          fill="var(--color-muted-foreground)"
          style={{ fontSize: "13px" }}
        >
          Lower 48 highlighted · NJ home base
        </text>
      </svg>

      <figcaption className="mt-4 flex flex-wrap items-center gap-4 text-sm text-muted-foreground">
        <span className="inline-flex items-center gap-2">
          <span className="h-3 w-3 rounded-sm bg-primary" aria-hidden="true" />
          {/* TODO: Narrow this legend once confirmed states/regions are provided. */}
          [STATES/REGIONS SERVED — default: all lower 48]
        </span>
        <span className="inline-flex items-center gap-2">
          <span className="h-3 w-3 rounded-full bg-accent" aria-hidden="true" />
          New Jersey home base
        </span>
      </figcaption>
    </figure>
  );
}
